(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REGIONS = ['北海道・東北', '関東', '中部', '近畿', '中国・四国', '九州・沖縄'];
  var CAT_PRIORITY = { '直営店': 1, 'アウトレット': 2, '取扱店': 3, '期間限定': 4 };

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function updateButtonGroup(bar, selector, activeValue) {
    bar.querySelectorAll(selector).forEach(function (btn) {
      var isActive = btn.dataset.value === activeValue;
      btn.classList.toggle('sf-btn--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function sortStoresInGrid(grid) {
    var cards = Array.from(grid.querySelectorAll('.store-card'));
    cards.sort(function (a, b) {
      var catA = parseInt(a.dataset.catOrder) || 99;
      var catB = parseInt(b.dataset.catOrder) || 99;
      if (catA !== catB) return catA - catB;

      var posA = parseInt(a.dataset.position) || 999;
      var posB = parseInt(b.dataset.position) || 999;
      if (posA !== posB) return posA - posB;

      return (a.dataset.name || '').localeCompare(b.dataset.name || '', 'ja');
    });
    cards.forEach(function (card) { grid.appendChild(card); });
  }

  function buildFilterHTML(cats) {
    var regionButtons = REGIONS.map(function (r) {
      return '<button type="button" class="sf-btn sf-region-btn" data-value="' + esc(r) + '" aria-pressed="false">' + esc(r) + '</button>';
    }).join('');

    var catButtons = cats.map(function (c) {
      return '<button type="button" class="sf-btn sf-cat-btn" data-value="' + esc(c) + '" aria-pressed="false">' + esc(c) + '</button>';
    }).join('');

    var rows = [];
    rows.push('<div class="sf-wrap">');
    rows.push('  <div class="sf-row sf-row--search">');
    rows.push('    <input type="search" class="sf-search" placeholder="店舗・住所で検索" aria-label="店舗・住所で検索">');
    rows.push('  </div>');
    rows.push('  <div class="sf-row">');
    rows.push('    <span class="sf-label">エリア</span>');
    rows.push('    <div class="sf-btn-group">' + regionButtons + '</div>');
    rows.push('  </div>');
    if (cats.length > 0) {
      rows.push('  <div class="sf-row">');
      rows.push('    <span class="sf-label">カテゴリ</span>');
      rows.push('    <div class="sf-btn-group">' + catButtons + '</div>');
      rows.push('  </div>');
    }
    rows.push('  <div class="sf-row sf-row--reset">');
    rows.push('    <button type="button" class="sf-reset">絞り込みをリセット</button>');
    rows.push('  </div>');
    rows.push('</div>');
    return rows.join('\n');
  }

  function initStoreFilter(bar) {
    var sectionId = bar.dataset.sectionId;
    var root = document.getElementById('section-' + sectionId);
    if (!root) return;

    var regionGroups = root.querySelectorAll('.store-region-group');
    var emptyMsg = root.querySelector('.store-filter-empty');
    var state = { text: '', region: '', category: '' };

    // ソート（カテゴリ優先度 → position → 店舗名）
    root.querySelectorAll('.store-grid').forEach(sortStoresInGrid);

    // 店舗が0件のリージョングループを初期非表示
    regionGroups.forEach(function (group) {
      if (group.querySelectorAll('.store-card').length === 0) {
        group.style.display = 'none';
      }
    });

    // カテゴリをDOMから収集（将来の追加カテゴリに対応）
    var catSet = new Set();
    root.querySelectorAll('.store-card').forEach(function (card) {
      var cat = (card.dataset.cat || '').trim();
      if (cat) catSet.add(cat);
    });
    var sortedCats = Array.from(catSet).sort(function (a, b) {
      var pa = CAT_PRIORITY[a] || 99;
      var pb = CAT_PRIORITY[b] || 99;
      if (pa !== pb) return pa - pb;
      return a.localeCompare(b, 'ja');
    });

    bar.innerHTML = buildFilterHTML(sortedCats);

    var searchInput = bar.querySelector('.sf-search');
    searchInput.addEventListener('input', function () {
      state.text = this.value.trim();
      applyFilters();
    });

    bar.querySelectorAll('.sf-region-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = this.dataset.value;
        state.region = (state.region === val) ? '' : val;
        updateButtonGroup(bar, '.sf-region-btn', state.region);
        applyFilters();
      });
    });

    bar.querySelectorAll('.sf-cat-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = this.dataset.value;
        state.category = (state.category === val) ? '' : val;
        updateButtonGroup(bar, '.sf-cat-btn', state.category);
        applyFilters();
      });
    });

    var resetBtn = bar.querySelector('.sf-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        state.text = '';
        state.region = '';
        state.category = '';
        searchInput.value = '';
        updateButtonGroup(bar, '.sf-region-btn', '');
        updateButtonGroup(bar, '.sf-cat-btn', '');
        applyFilters();
      });
    }

    function applyFilters() {
      var textLower = state.text.toLowerCase();
      var totalVisible = 0;

      regionGroups.forEach(function (group) {
        var groupRegion = group.dataset.region || '';
        var matchRegion = !state.region || groupRegion === state.region;

        if (!matchRegion) {
          group.style.display = 'none';
          return;
        }

        var groupVisible = 0;
        group.querySelectorAll('.store-card').forEach(function (card) {
          var name = (card.dataset.name || '').toLowerCase();
          var address = (card.dataset.address || '').toLowerCase();
          var cat = (card.dataset.cat || '').trim();

          var matchText = !state.text || name.includes(textLower) || address.includes(textLower);
          var matchCat = !state.category || cat === state.category;

          var visible = matchText && matchCat;
          card.style.display = visible ? '' : 'none';
          if (visible) { groupVisible++; totalVisible++; }
        });

        group.style.display = groupVisible > 0 ? '' : 'none';
      });

      if (emptyMsg) emptyMsg.style.display = (totalVisible === 0) ? '' : 'none';
    }
  }

  function init() {
    document.querySelectorAll('.store-filter-bar').forEach(function (bar) {
      initStoreFilter(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
